import {InitPage} from "../index";

class MfApiLogs {
    constructor() {
        $('.apiFilter').select2({
            placeholder: 'API Name',
            allowClear: true
          });

        $('#module_name_log').on('select2:select', function (e) {
            $('#search-log-form').submit();
        });

        $('.all_rows').on('click', function(){
            if($(this).is(':checked'))
            {
                $('.details_row').addClass('in');
                $('.accordion-arrow-icon').addClass('fa-chevron-up');
                $('.accordion-arrow-icon').removeClass(' fa-chevron-down');
            }
            else
            {
                $('.details_row').removeClass('in');
                $('.accordion-arrow-icon').addClass('fa-chevron-down');
                $('.accordion-arrow-icon').removeClass(' fa-chevron-up');
            }
            $('#main').attr('style','min-height: ' + $('.table').height() + 'px !important;');
        });

        const accordionIcon = $(".accordion-arrow-icon");
        accordionIcon.on("click", (e) => {
            if (e.target.classList.contains("fa-chevron-down")) {
                e.target.classList.remove("fa-chevron-down");
                e.target.classList.add("fa-chevron-up");
            } else {
                e.target.classList.add("fa-chevron-down");
                e.target.classList.remove("fa-chevron-up");
            }
        });

    }
}

export function LoadPage() {
    InitPage("api_logs index", () => {
        const c = new MfApiLogs();
    });
}
